import React, { useState, useEffect, useRef } from "react";
import { Button, Modal } from 'react-bootstrap';
import C4FSimpleTable from "../common/C4FSimpleTable";

function WeatherForecastModal(props) {

    const mounted = useRef(false);
    const [show, setShow] = useState(false);
    const handleClose = () => props.handleClose();

    function translateDegreesToDirection(degrees) {
        switch (Math.round(degrees / 22.5)) {
            case 1: return 'NNE';
            case 2: return 'NE';
            case 3: return 'ENE';
            case 4: return 'E';
            case 5: return 'ESE';
            case 6: return 'SE';
            case 7: return 'SSE';
            case 8: return 'S';
            case 9: return 'SSW';
            case 10: return 'SW';
            case 11: return 'WSW';
            case 12: return 'W';
            case 13: return 'WNW';
            case 14: return 'NW';
            case 15: return 'NNW';
            default: return 'N';
        }
    }

    useEffect(() => {
        mounted.current = true;
    }, []);

    useEffect(() => {
        return () => mounted.current = false;
    }, []);

    useEffect(() => {
        if (mounted.current) {
            setShow(props.show);
        }
        else {
        }
    }, [props.refresh]);

    return <>
        <Modal key={'WeatherForecastModal' + show}
            size="lg"
            show={show}
            onHide={handleClose} >
            <Modal.Header>
                <Modal.Title>Weather Forecasts</Modal.Title>
                <Button variant="danger py-0 m-0" onClick={handleClose}>{'X'}</Button>
            </Modal.Header>
            <Modal.Body closeButton style={{ backgroundColor: 'rgba(222,233,244,1)', padding: 0, margin: 0 }}>
                <C4FSimpleTable
                    data={props.weatherForecast.map(weatherForecast => ({
                        ...weatherForecast,
                        windDirectionDegreesAndText: weatherForecast.windDirection + ' (' + translateDegreesToDirection(weatherForecast.windDirection) + ')',
                        cityCountry: weatherForecast.cityName + ' (' + weatherForecast.countryCode + ')',
                        requestDateTrunc: 'requestDate' in weatherForecast ? 
                            weatherForecast.requestDate.split(' ')[0] : weatherForecast.creationDate.split(' ')[0]
                    }))}
                    hideFilterButtons={true}
                    rowMetadata={[
                        { columnName: 'forecastKm', columnDescription: 'km' },
                        { columnName: 'cityCountry', columnDescription: 'Location' },
                        { columnName: 'requestDateTrunc', columnDescription: 'Forecast Date' },
                        { columnName: 'temperature', columnDescription: 'Temp' },
                        { columnName: 'precipitationProbability', columnDescription: 'Rain %' },
                        { columnName: 'precipitationAmount', columnDescription: 'Rain mm' },
                        { columnName: 'windSpeed', columnDescription: 'Wind m/s' },
                        { columnName: 'windDirectionDegreesAndText', columnDescription: 'Direction' },
                        { columnName: 'cloudCover', columnDescription: 'Cloud %' }
                    ]}
                />
            </Modal.Body>
        </Modal>
    </>
}

export default WeatherForecastModal;